<template>
  <div style="height: 100%;">
  <k-panel fill-height>
    <template #title>
      <k-layout row wrap>
        <k-flex c1>
          <date-picker :disabledAfter="filters.daterange.end" first-day-of-week="1" v-model="filters.daterange.start" label="From"></date-picker>
        </k-flex>
        <k-flex c1>
          <date-picker :disabledBefore="filters.daterange.start" first-day-of-week="1" v-model="filters.daterange.end" label="To"></date-picker>
        </k-flex>
        <k-flex c1>
          <k-checkbox hide-details color="deep-orange" label="Active" v-model="filters.states" input-value="active"></k-checkbox>
        </k-flex>
        <k-flex c1>
          <k-checkbox hide-details color="deep-orange" label="Archived" v-model="filters.states" input-value="archived"></k-checkbox>
        </k-flex>
      </k-layout>      
    </template>
    <template #default>
    <k-data-table :loading="table_loading" :headers="headers" :items="eventList" :pagination.sync="pagination" :rows-per-page-items="[5, 15, 25, 50, 100, { text: 'All', value: -1 }]">
      <template slot="items" slot-scope="props">
        <tr :active="$route.params.id == props.item.uuid" @click.stop="openEditEvent(props.item.uuid)" :class="if_archived_color(props.item.state)">
          <td>{{ props.item.title }}</td>
          <td>{{ props.item.subtitle }}</td>
          <td>{{ props.item.input.title }}</td>
          <td>{{ props.item.output.title }}</td>
          <td>{{ format_date(props.item.start_time) }}</td>
          <td>{{ format_date(props.item.end_time) }}</td>
        </tr>
      </template>
    </k-data-table>
    </template>
  </k-panel>
      <action-buttons @add="openAddEvent"></action-buttons>

  </div>
</template>

<script>
import datelib from '@/lib/date.js';
import moment from 'moment';
import strftime from 'strftime';
import DatePicker from '../DatePicker'
import EventModel from '@/models/event.js'
import ActionButtons from '@/components/ActionButtons.vue'

export default {
  components: {
    DatePicker,
    ActionButtons
  },
  localStorage: {
    eventListFilters: {
      type: Object,
      default: undefined
    }
  },
  data () {
    var start_date = moment().startOf('day').toDate();
    var end_date = moment().add(1, 'weeks').endOf('day').toDate();
    return {
      channel: undefined,
      events: [],
      filters: {
        daterange: {
          start: start_date,
          end: end_date
        },
        states: ["active"]
      },
      headers: [
        { text: 'Title', value: 'title', align: 'left' },
        { text: 'Subtitle', value: 'subtitle', align: 'left' },
        { text: 'Source', value: 'input', align: 'left'},
        { text: 'Destination', value: 'output', align: 'left'},
        { text: 'Kickoff time', value: 'start_time', align: 'left' },
        { text: 'End time', value: 'end_time', align: 'left' }
      ],
      pagination: {
        sortBy: 'start_time',
        descending: true,
        rowsPerPage: 25
      },
      table_loading: false,
    }
  },
  watch: {
    filters: {
      handler () {
        this.filterEvents();
      },
      deep: true
    },
    '$route' (to,from) {
      if(to.path == "/events/list" && (from.path == "/events/new" || from.path.indexOf("/events/edit/") != -1)) {
        this.filterEvents();
      }
    }
  },
  methods: {
    if_archived_color(state) {
      return state == 'archived' ? this.$dark() ? 'grey darken-2 grey--text' : 'grey lighten-4' : ''
    },
    filterEvents () {
      var self = this;
      this.table_loading = true;
      var _filters = _.cloneDeep(this.filters);
      if(typeof(_filters.daterange.start) != "undefined") {
        _filters.daterange.start = moment(_filters.daterange.start).startOf('day').unix();
      }
      if(typeof(_filters.daterange.end) != "undefined") {
        _filters.daterange.end = moment(_filters.daterange.end).endOf('day').unix();
      }


      this.channel.push("filter_reply", _filters)
        .receive("ok", (msg) => {
          self.events = msg.events;
          self.table_loading = false;

        })
        .receive("error", (msg) => {
          console.log("Event filter failed");
        });


//      this.channel.push("filter", _filters);


      this.$localStorage.set('eventListFilters', _filters)
    },
    format_date (v) {
      return datelib.format_date(v) + " - " + datelib.format_time(v);
    },
    openAddEvent () {
      this.$router.push("/events/new")
    },
    openEditEvent (uuid) {
      this.$router.push("/events/edit/"+uuid)
    },
    connect_ws () {
      var self = this;
      this.channel = this.$socket.channel("events:all");
      this.channel.on("init", function(msg) {
        console.log("EVENTS INIT", msg);
        self.filterEvents();
      });
/*      this.channel.on("events", function(msg) {
        self.events = msg.events;
        self.table_loading = false;
      });*/
      this.channel.on("event-update", function(msg) {
        console.log("EVENT-UPDATE", msg)
        self.filterEvents();
      });
      this.channel.join();
      console.log("JOINED CHANNEL");
    }
  },
  computed: {
    search_text () {
      return this.$store.state.search_text;
    },
    eventList () {
      var events = this.events;
      var account = this.$store.state.account;
      var search = (this.search_text || "").toLowerCase();
      var ret = events.map((event) => {
        var start_time = (event.event_group||{}).start_time;
        return {
          uuid: event.uuid,
          title: EventModel.title(event),
          subtitle: EventModel.subtitle(event),
          start_time: start_time,
          end_time: event.cached_end_time,
          state: event.state,
          output: EventModel.output_channel(event)||{title: ""},
          input: EventModel.input_channel(event)||{title: ""}
        }
      });

      if (search.length > 0) {
        ret = _.filter(ret, function(event) {
          ret = false;
          if (event.title.toLowerCase().includes(search)) ret = true;
          if (event.subtitle.toLowerCase().includes(search)) ret = true;
          if (event.input.title.toLowerCase().includes(search)) ret = true;
          if (event.output.title.toLowerCase().includes(search)) ret = true;
          return ret;
        })
      }

      return ret
    }
  },
  mounted () {
    var filters = this.$localStorage.get('eventListFilters');
    if(!_.isEmpty(filters)) {
      filters.daterange.start = moment.unix(filters.daterange.start).toDate()
      filters.daterange.end = moment.unix(filters.daterange.end).toDate()
      this.filters = filters
    }
    this.connect_ws();
  }
}
</script>
